import axios from "axios";
import qs from "qs";
import { AxiosCanceler } from "./axiosCancel";
import { isIE } from "@/assets/js/utils";
import Topic from "./topic.js";

let topic = new Topic();
axios.defaults.timeout = 1000 * 60 * 60 * 30;
axios.defaults.withCredentials = true;

// axios.defaults.baseURL = 'https://10.10.111.85:8080'
console.log('process.config.env.AXIOS_BASEURL',process.config.env.AXIOS_BASEURL);
axios.defaults.baseURL = process.config.env.AXIOS_BASEURL ? process.config.env.AXIOS_BASEURL : "";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded",
};
// 取消加载的句柄
let axiosCanceler = new AxiosCanceler();
// 允许多并发的接口
let allow_multiple_api = ['/customer/common/platformServiceDetail', "/customer/upload", "/llm/identify"]

// home下  <router-view v-loading="showLoading"  /> 需要laoding的接口

let notLogin = ["/external/lawsuit/completeByJump"];

//http 请求 拦截器
axios.interceptors.request.use(
  (config) => {
    if (config && !allow_multiple_api.includes(config.url)) {
      axiosCanceler.addPending(config);
    }

    if (config.url != '/llm/identify' && config.loading == 'loading') {
      topic.loadingOpen(config.url);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http 响应 拦截器
axios.interceptors.response.use(
  (response) => {
    // console.log(response,"response")
    if (response && response.config.url != "/customer/upload") {
      axiosCanceler.removePending(response.config);
    }
    topic.loadingClose(response.config.url);
    try {
      if (response.data.code == 401 && notLogin.indexOf(response.config.self.$route.path) == -1) {
        if(window.location.href.indexOf("/loan/apply") > -1){
          console.log('window.location.href',window.location.href);
          window.location.href = "#/login?type=loanApply";
        }else{
          window.location.href = "#/login";
        }
        axiosCanceler.removeAllPending();
        localStorage.setItem("relogin", "1");

        return response.data;
      }

      if (response.data.code == 1000 || response.data.code == 500) {

        topic.tipsOpen(response.config.url, {
          msg: response.data.msg || "系统异常,请联系客服",
          type: "error",
          serverError: true,
        });
        return response.data;
      }
    } catch (e) {
      console.log(e);
    }
    return response.data;
  },
  (error) => {
    console.log(error);
    topic.loadingClose();
    return Promise.reject(error.response);
  }
);
let hasOwnProperty = Object.prototype.hasOwnProperty;
export default {
  post: function (param) {
    return new Promise((resolve, reject) => {
      var cache = param.cache || false; // 是否缓存  不适用参数的情况，否则导致数据无法更新,尽适用于静态数据
      if (cache && sessionStorage.getItem('CACHE_AJAX_' + param.url)) {
        let res = JSON.parse(sessionStorage.getItem('CACHE_AJAX_' + param.url));
        param.success(res);
        resolve(res);
        return;
      }
      var url = param.url;
      axios({
        method: "post",
        url: url,
        data: qs.stringify(param.data),
        self: param.self,
        loading: param.loading || 'loading',
      })
        .then((res) => {
          if (res.code == 200) {
            if (hasOwnProperty.call(res, "data")) {
              param.success && param.success(res.data);
              if (param.cache) {
                sessionStorage.setItem("CACHE_AJAX_" + param.url, JSON.stringify(res.data));
              }
            } else {
              param.success && param.success(res);
              if (param.cache) {
                sessionStorage.setItem("CACHE_AJAX_" + param.url, JSON.stringify(res));
              }
            }
          } else {
            if (param.self && param.self.tips) {
              param.self.tips.msg = res.msg || "";
              param.self.tips.type = "error";
            }
            param.fail && param.fail(res);
          }
          resolve(res);
        })
        .catch((err) => {
          if (err) {
            reject(err);
            param.fail && param.fail(err);
          }

        });
    });
  },
  get: function (param) {
    return new Promise((resolve, reject) => {
      var url = param.url;
      var timeStamp = new Date().getTime();
      if (isIE()) {
        url = url + '?t=' + timeStamp;
      }
      axios({
        method: "get",
        url: url,
        // params: qs.stringify(param.data),
        params: param.data,
        self: param.self,
      })
        .then((res) => {
          if (res.code == 200) {
            if (hasOwnProperty.call(res, "data")) {
              param.success && param.success(res.data);
            } else {
              param.success && param.success(res);
            }
          } else {
            if (param.self && param.self.tips) {
              param.self.tips.msg = res.msg || "";
              param.self.tips.type = "error";
            }
            param.fail && param.fail(res);
          }
          resolve(res);
        })
        .catch((err) => {
          if (err) {
            reject(err);
            param.fail && param.fail(err);
          }
        });
    });
  },

  uploadFile: function (param) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: param.url,
        data: param.data,
        withCredentials: false,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: param.timeout ? param.timeout : 300000,
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let progress = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onUploadProgress ? param.onUploadProgress(progress) : "";
        },
      })
        .then((res) => {
          if (res.code == 1000) {
            param.fail && param.fail(res);
            reject(res);
          }
          if (res.code == 200) {
            param.success && param.success(res.data);
            resolve(res.data);
          }
        })
        .catch((err) => {
          param.fail && param.fail(err);
          reject(err);
        });
    });
  },
};
